export async function enableMocking(): Promise<void> {
  if (import.meta.env.VITE_MSW_ENABLED !== 'true') return;

  const { worker } = await import('@/test/mocks/browser');
  await worker.start({ onUnhandledRequest: 'bypass' });
}
